import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  submit () {
    // Ask Turbo nicely to submit the form
    // https://stackoverflow.com/questions/68624668/how-can-i-submit-a-form-on-input-change-with-turbo-streams
    this.element.requestSubmit()
  }
}
